import { ConditionType } from "common/types/condition-type";

export const translateConditionType = (ct: ConditionType) =>
  ct === "column" ? _("Column") : _("Input");
